export const MIN_RESTRICTED_AGE = 15
export const ADULT_AGE = 18

export function formatBirthdateInput(value) {
  const raw = String(value || '')
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month, day] = raw.split('-')
    return `${day}/${month}/${year}`
  }
  const digits = raw.replace(/\D/g, '').slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

export function birthdateInputToIso(value) {
  const raw = String(value || '').trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw
  const match = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  if (!match) return ''
  const [, day, month, year] = match
  const parsed = new Date(Number(year), Number(month) - 1, Number(day))
  if (
    parsed.getFullYear() !== Number(year)
    || parsed.getMonth() + 1 !== Number(month)
    || parsed.getDate() !== Number(day)
  ) {
    return ''
  }
  return `${year}-${month}-${day}`
}

export function ageFromBirthdate(value, today = new Date()) {
  const isoValue = birthdateInputToIso(value)
  if (!isoValue) return null
  const parts = isoValue.split('-').map(Number)
  if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) return null
  const [year, month, day] = parts
  if (year < 1900 || month < 1 || month > 12 || day < 1 || day > 31) return null
  let age = today.getFullYear() - year
  const currentMonth = today.getMonth() + 1
  const currentDay = today.getDate()
  if (currentMonth < month || (currentMonth === month && currentDay < day)) age -= 1
  return age
}

export function requiresGuardianAuthorization(value) {
  const age = ageFromBirthdate(value)
  return age !== null && age >= MIN_RESTRICTED_AGE && age < ADULT_AGE
}

export function isUnderRestrictedAge(value) {
  const age = ageFromBirthdate(value)
  return age !== null && age < MIN_RESTRICTED_AGE
}

export function isAgeVerifiedForRestrictedUse(profile) {
  const birthdate = profile?.date_of_birth || profile?.dateOfBirth || ''
  const age = ageFromBirthdate(birthdate)
  if (age === null || age < MIN_RESTRICTED_AGE) return false
  if (age >= ADULT_AGE) return true
  return String(profile?.guardian_consent_status || '').toLowerCase() === 'granted'
}
